import { useState } from "react";

/**
 * Custom hook to manage video modal state across question components
 * This hook provides consistent video modal behavior for all question types
 */
export const useVideoModal = () => {
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

  /**
   * Handle video modal toggle - can be called with true/false or without params to toggle
   * @param {boolean} isOpen - Optional: true to open, false to close
   */
  const handleVideoModalToggle = (isOpen) => {
    if (typeof isOpen === "boolean") {
      setIsVideoModalOpen(isOpen);
    } else {
      setIsVideoModalOpen((prev) => !prev);
    }
  };

  /**
   * Explicitly open the video modal
   */
  const openVideoModal = () => {
    setIsVideoModalOpen(true);
  };

  /**
   * Explicitly close the video modal
   */
  const closeVideoModal = () => {
    setIsVideoModalOpen(false);
  };

  return {
    isVideoModalOpen,
    handleVideoModalToggle,
    openVideoModal,
    closeVideoModal,
  };
};
